module.exports = __webpack_public_path__ + "static/css3-2fa5f98210046b7db465d3c7d0af1c4d.png";